export default __webpack_public_path__ + "static/media/ProfileImg.440597e4.jpg";